import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import _ from "lodash";
import styled, { css } from "styled-components";

import { Breadcrumb, Button, Container, Frame, RowWrapper, TExtra } from "components/ui-kit/styled-templates";
import Tooltip from "components/ui-kit/tooltip";

import ClubsApi from "api/clubs-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import useStepsOptions from "hooks/useStepsOptions";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ESteps } from "types/enums";
import EditClubModal from "../modals/edit-club-modal";

const MyClubsPage = () => {
    const { t, i18n } = useTranslation();

    useBodyBackground(`white`);
    const navigate = useNavigate();

    let isRu = i18n.language === "ru";

    const clubs = useStorageListener(
        (state) => _.values(state?.clubs)?.filter?.((i: any) => i?.universityId === state?.myUniversityId) ?? [],
    );

    const handlers = {
        createClub: () => {
            ModalsService.showModal(EModals.CreateClub, { mode: `create` });
        },
        editClub: (id: string) => () => {
            ModalsService.showModal(EModals.CreateClub, { mode: `edit`, data: _.find(clubs, { id }) });
        },
        deleteClub: (id: string) => async () => {
            ModalsService.showModality({
                title: `Удаление клуба`,
                description: `Вы уверены, что хотите удалить клуб "${
                    _.find(clubs, { id })?.details?.name ?? `без названия`
                }"?`,
                cancelButton: {
                    children: `Отмена`,
                    background: `gray`,
                    onClick: () => {},
                },
                confirmButton: {
                    children: `Удалить`,
                    background: `red`,
                    // onClick: async () => await ClubsApi.deleteClub(id),
                    onClick: () => {
                        ClubsApi.deleteClub(id);
                    },
                },
            });
        },
    };

    // @ts-ignore
    useEffect(ClubsApi.getMyClubs, []);

    return (
        <>
            <EditClubModal/>
            <Container extra={`align-items: flex-start;`}>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("qys77ygwrz")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <RowWrapper extra={`h1 { margin: 0; };`}>
                    <h1>{t("my_clubs")}</h1>
                    <Button variant="outlined" onClick={handlers.createClub}>
                        {isRu ? 'Добавить студтурклуб' : 'Add tour club'}
                    </Button>
                </RowWrapper>
                <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 40px;`}>
                    {clubs?.map?.(({ details: item = {}, id, onModeration, moderationComment }: any, index: any) => (
                        <ClubTab.Component key={index} {...{ item, id, handlers, onModeration, moderationComment }} />
                    ))}
                </RowWrapper>
                {!clubs.length && <NotFoundWrapper>{t("3085txvws7m")}</NotFoundWrapper>}
            </Container>
        </>
    );
};


enum EClubTabStatus {
    Accept = `accept`,
    Reject = `reject`,
    Process = `process`,
    None = `none`,
    Verification = `verification`,
}

const tooltipStatusText = {
    [EClubTabStatus.Accept]: `Все данные успешно заполнены, проверка пройдена`,
    [EClubTabStatus.Verification]: `Все данные успешно заполнены, ожидает проверки`,
    [EClubTabStatus.Reject]: `Ожидает заполнения`,
    [EClubTabStatus.Process]: `Ожидает заполнения`,
    [EClubTabStatus.None]: `Ожидает заполнения`,
};



export const ClubTab = {
    Component: (props: { onModeration: boolean; moderationComment: any, item: any; id: string; handlers: { editClub: Function; deleteClub: Function } }) => {
        const { t } = useTranslation();

        const { item, id, handlers, onModeration, moderationComment } = props;

        const status = onModeration ? EClubTabStatus.Verification : EClubTabStatus.Accept;

        return (
            <ClubTab.Wrapper>
                <ClubTab.WarningSign status={status} />
                <ClubTab.Name empty={_.isEmpty(item?.name)}>{item?.name ?? `Без имени`}</ClubTab.Name>
                {((onModeration == true) && (moderationComment != undefined)) ?
                    <>
                        <div style={{color: 'red', opacity: 0.5}} className={'flex flex-row items-center'} >
                            <span className={'mr-1 '}  >
                                <svg height={22} style={{display: 'inline-block', marginTop: '-4px'}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                     stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                                </svg>
                            </span>
                            {`Комментарий модерации: ${moderationComment}`}
                        </div>
                    </>
                    : null
                }
                {/*<ClubTab.Type>{EVENT_TYPES_OPTIONS?.find?.((i) => i?.value === item?.type)?.clubel}</ClubTab.Type>*/}
                <ClubTab.DetailsWrapper>
                    {/*<div>*/}
                    {/*    <div>Стоимость на 1 человека:</div>*/}
                    {/*    <strong>{item?.price} ₽</strong>*/}
                    {/*</div>*/}
                    {/*<div>*/}
                    {/*    <div>Даты проведения:</div>*/}
                    {/*    <strong>*/}
                    {/*        {moment(item?.dates?.from).format(`DD.MM`)} - {moment(item?.dates?.to).format(`DD.MM`)}*/}
                    {/*    </strong>*/}
                    {/*</div>*/}
                </ClubTab.DetailsWrapper>
                {/*<Link to={`/clubs/${id}`}>*/}
                {/*    <ClubTab.Link color="blue">Предпросмотр</ClubTab.Link>*/}
                {/*</Link>*/}
                <ClubTab.Link color="blue" onClick={handlers.editClub(id)}>
                    {t("pzj6pcmxt3p")}
                </ClubTab.Link>
                <ClubTab.Link color="red" onClick={handlers.deleteClub(id)}>
                    {t("qlpwlvqsvva")}
                </ClubTab.Link>
            </ClubTab.Wrapper>
        );
    },
    Type: styled(Frame)`
      color: ${({ theme }) => theme.blue};
      font-size: 13px;
      line-height: 17px;
    `,
    WarningSign: styled(Frame)<{ status?: EClubTabStatus }>`
      width: 24px;
      height: 24px;
      background: url("${({ status = EClubTabStatus.None }) => require(`assets/icons/dormitory-status-${status}.svg`)}") no-repeat center center /
            contain;

      position: absolute;
      top: 10px;
      right: 10px;
    `,
    Wrapper: styled(Frame)<{ status?: EClubTabStatus }>`
      width: calc(50% - 20px);
      padding: 24px 20px;
      box-sizing: border-box;
      border: 1px solid ${({ theme }) => theme.halfblue};
      border-radius: 8px;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px 0;
      position: relative;

      > * {
        margin: 0;
      }

      @media (max-width: 991px) {
        width: inherit;
      }
    `,
    Name: styled.h3<{ empty: boolean; extra?: TExtra }>`
        color: ${({ theme, empty }) => (empty ? theme.text.light : theme.text.primary)};

        ${({ extra }) => extra}
    `,
    Link: styled(Frame)<{ color: `red` | `blue`; direction?: `right` | `left` }>`
        color: ${({ theme, color }) => theme[color]};
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        display: flex;
        align-items: center;
        flex-direction: row;
        cursor: pointer;

        ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
            content: "";
            width: 12px;
            height: 12px;
            background: url("${({ color }) => require(`assets/icons/arrow-right-${color}.svg`)}") no-repeat center center / contain;
            margin-left: 8px;
            transition: 0.2s;

            ${({ direction = `right` }) =>
        direction === `left` &&
        css`
                    transform: rotate(180deg);
                    margin-left: unset;
                    margin-right: 8px;
                `}
        }

        &:hover {
            ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
                transform: translateX(${({ direction = `right` }) => (direction === `right` ? 3 : -3)}px)
                    ${({ direction = `right` }) => (direction === `left` ? `rotate(180deg)` : ``)};
            }
        }
    `,
    DetailsWrapper: styled(RowWrapper)`
        > * {
            margin-bottom: 8px;
            width: 100%;

            p {
                margin-bottom: 8px;
            }
        }

        @media (max-width: 991px) {
            flex-wrap: wrap;
            > * {
                width: 50%;
            }
        } ;
    `,
};

export const NotFoundWrapper = styled(Frame)`
    width: inherit;
    color: ${({ theme }) => theme.grey};
    padding: 40px 0;
`;

export default MyClubsPage;
